import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';

export default function ChannelActivityPage() {
  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA] mb-2">
            Channel Activity
          </h1>
          <p className="text-[#ADB5BD]">Track IB Activities & Schedule</p>
        </div>
        <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
          <h3 className="text-xl font-semibold mb-4">Activity Calendar</h3>
          <p className="text-[#ADB5BD] mb-6">Daily & hourly activity tracking - Livetrade, Webinar, Signal, Content shooting</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs uppercase tracking-wider text-[#ADB5BD] mb-3">Upcoming Activities</p>
              <div className="space-y-2">
                <div className="flex items-center justify-between p-2 bg-[#1C1C1F] rounded">
                  <div>
                    <p className="text-[#F8F9FA]">📹 Livetrade Session</p>
                    <p className="text-xs text-[#6C757D]">Today, 8:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 bg-[#1C1C1F] rounded">
                  <div>
                    <p className="text-[#F8F9FA]">📊 Webinar: Market Analysis</p>
                    <p className="text-xs text-[#6C757D]">Tomorrow, 3:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 bg-[#1C1C1F] rounded">
                  <div>
                    <p className="text-[#F8F9FA]">📱 Signal Broadcast</p>
                    <p className="text-xs text-[#6C757D]">Tomorrow, 10:00 AM</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs uppercase tracking-wider text-[#ADB5BD] mb-3">KPI & Target per Activity</p>
              <div className="space-y-3">
                <div>
                  <p className="text-sm text-[#ADB5BD] mb-1">Livetrade: Avg Viewers</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">150+</p>
                </div>
                <div>
                  <p className="text-sm text-[#ADB5BD] mb-1">Webinar: Registration</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">80+</p>
                </div>
                <div>
                  <p className="text-sm text-[#ADB5BD] mb-1">Signal: Win Rate</p>
                  <p className="text-2xl font-mono text-[#06D6A0]">75%+</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    </ResponsiveLayout>
  );
}
